import React from 'react';

import SvgArrowRight from '~svg/SvgArrowRight';

// A "Scroll for more" hint that sits under the nav controls, with an arrow on
// each side of the text. Shown only when the controls row actually overflows -
// the parent measures that and passes `visible`. Positioned within
// `.top-nav__track` (see ScrollHint.less).
const ScrollHint = ({ visible }: ScrollHintTypes) => (
	<span className={visible ? 'scroll-hint is-visible' : 'scroll-hint'}>
		<SvgArrowRight />
		Scroll for more
		<SvgArrowRight />
	</span>
);

type ScrollHintTypes = {
	visible: boolean;
};

export default ScrollHint;
